import { api } from './api';

const getAll = async () => {
  try {
    const result = await api.get(`/v2/funnel/globalUpdateConfig/`);
    return result;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const deleteOne = async objectId => {
  try {
    await api.delete(`/v2/funnel/globalUpdateConfig/${objectId}`);
    return true;
  } catch (e) {
    console.error('deleteOne', e);
    return false;
  }
};

const addOne = async datas => {
  try {
    await api.post(`/v2/funnel/globalUpdateConfig`, datas);
    return true;
  } catch (e) {
    console.error('addOne', e);
    return false;
  }
};

const updateOne = async (id, datas) => {
  try {
    await api.put(`/v2/funnel/globalUpdateConfig/${id}`, datas);
    return true;
  } catch (e) {
    console.error('updateOne', e);
    return false;
  }
};
const getByFunnelId = async funnelId => {
  try {
    const { data } = await api.post(`/v2/funnel/globalUpdateConfig/funnel`, {
      funnelId
    });

    return data || null;
  } catch (e) {
    console.error('getByFunnelId', e);
    return undefined;
  }
};

export default { getAll, deleteOne, addOne, updateOne, getByFunnelId };
